
import { getServiceReportMeterStyleByType } from "@/_constants/serviceReportMeter.ts";
import { getDateFromIso } from "@/_helpers/stringHelper.ts";
import {
  OperatingStatus,
  OperatingStatusKey,
} from "@/common/enums/sharedEnums.ts";

import { Meter } from "../../../serviceOrdering/interfaces/ServiceReport.ts";

export interface FullColoredCardProps {
  meter: Meter;
  type: string;
}

const FullColoredCard = ({
  meter: {
    lastMeasurementDate,
    location,
    measurement,
    name,
    serialNumber,
    operatingStatus,
    unit,
    type,
  },
}: FullColoredCardProps) => {
  const { color, icon } = getServiceReportMeterStyleByType(type);

  return (
    <div className={`dwelling_meter dwelling_meter-${type}`}>
      <div className="dwelling_meter-header">
        <span>{icon({ color })}</span>
        <span>{name}</span>
      </div>

      {operatingStatus === null || operatingStatus === OperatingStatusKey.F ? (
        <>
          <div className="dwelling_meter-location">
            <span>{location}</span>
          </div>
          <div className="dwelling_meter-measure">
            <div>
              {measurement} {unit}
            </div>
          </div>
          <div className="dwelling_meter-footer">
            <div>
              Dernier relevé effectué le {getDateFromIso(lastMeasurementDate)}
            </div>
            <div> N° de série : {serialNumber}</div>
          </div>
        </>
      ) : (
        <div className="dwelling_meter-measure dwelling_meter-missing">
          <div>{OperatingStatus[operatingStatus]}</div>
        </div>
      )}
    </div>
  );
};

export default FullColoredCard;
